/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { HandleReplyInAction } from './handleReplyInAction';

export interface HandleReplyIn {
  action: HandleReplyInAction;
  participant_id?: string | null;
}
